import React from 'react';
import { Typography } from '@material-ui/core';

import StefanZechmannHero from '../../../../../../../images/test-assignment-zechmann-hero-it.png';

const IT = () => (
  <>
    <img
      src={StefanZechmannHero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        Il Dr. Stefan Zechmann ti ha assegnato un test di laboratorio da
        effettuare a casa.
        <br />
        <br />
        Ti preghiamo di seguire questi passaggi:
        <br />
        <br />
        <b>1. Ordina il test</b>
        <br />
        Clicca sul pulsante &quot;Ordina&quot; alla fine di questa e-mail e
        segui le istruzioni per completare l’ordine.
        <br />
        <br />
        <b>Nota bene:</b> Si tratta di una prestazione a carico del paziente.
        Non è previsto alcun rimborso tramite l’assicurazione di base.
        <br />
        <br />
        <b>2. Esegui comodamente il test a casa</b>
        <br />
        2-3 giorni lavorativi dopo l’ordine, riceverai il tuo kit di test in una
        busta discreta tramite posta. Il kit contiene un codice di attivazione,
        tutto il materiale necessario e istruzioni chiare per il prelievo del
        campione. Dopo aver effettuato il prelievo, inserisci il campione nella
        scatola di ritorno fornita e imbucala in una qualsiasi cassetta postale
        della Posta Svizzera.
        <br />
        <br />
        <b>3. Ricevi i risultati</b>
        <br />
        Il tuo campione sarà analizzato da Medisyn, un importante fornitore di
        servizi di laboratorio in Svizzera. Non appena i risultati saranno
        pronti, riceverai un’e-mail con un link per prenotare la tua consulenza
        di follow-up con il Dr. Stefan Zechmann. Dopo tale consulenza, i
        risultati saranno messi a tua disposizione online.
      </Typography>
      <button type="button" className="sidebar__button">
        Ordina il test assegnato
      </button>
      <Typography variant="body2">
        Se hai domande, puoi contattarci in qualsiasi momento all’indirizzo:
        service@yourself.health
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        Non vuoi più ricevere queste e-mail? Annulla l’iscrizione
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default IT;
